import { ILabels } from "@/apps/StudentExchangeProgressColumnWidget/models/config-viewmodel";

export interface StudentExchangeProgressColumnWidget {
    labels: ILabels
    progressLabels: []
}

export class WidgetState implements StudentExchangeProgressColumnWidget {
    labels: ILabels = {
        progressBarTitle: '',
        progressBarProgressLabel: ''
    }
    progressLabels: [] = []
}
